<template>
  <div>
    <v-layout row wrap justify-center align-center text-xs-center pb-5 mt-5 class="cont_page">
      <v-flex xs12 sm9 md7 mt-4 class="text-xs-left">
            <h1 class="animated bounceIn dura-1"><span class="icon-titulo"></span>Evaluación de atmósferas</h1>    
            <h2 class="animated bounceIn dura-2">Prueba de gases </h2>
      </v-flex>
      <v-flex xs12 sm7 md7 mt-2 class="text-xs-left">
        <span><strong>Condiciones que afectan la medición</strong></span>
      </v-flex>
      <v-flex xs12 sm7 md7 >
          <img class="animated flipInY dura-1" :src="require('../../assets/unidad2/pantalla7-1.png')" alt="" v-show="!$vuetify.breakpoint.xs">
           <!-- <svg3-app v-show="!$vuetify.breakpoint.xs"></svg3-app >  -->
          <!-- <svg4-app v-show="$vuetify.breakpoint.xs"></svg4-app >  -->
          <img class="animated flipInY dura-1" :src="require('../../assets/unidad2/pantalla-7-1-mobile.png')" alt="" v-show="$vuetify.breakpoint.xs">
      </v-flex>
      <v-flex xs12 sm7 md7 class="text-xs-left">
          <span><strong>Ten en cuenta que: </strong></span>
      </v-flex>
      <scrolldown-app></scrolldown-app>
      <v-flex xs12 sm7 md6 class="animated fadeInUp text-xs-center">
              <v-card color="transparent" flat tile> 
                  <v-window v-model="onboarding">                
                    <v-window-item  v-for="n in length" :key="`card-${n}`">
                      <v-card class="cont_text-slider" color="transparent" flat>
                        <div class="flip-item">
                          <img class="animated flipInY dura-1" :src="require('../../assets/unidad2/pantalla-7-'+n+'.png')" alt="">
                          <v-layout justify-center  class="text-xs-left">
                          <v-flex xs12 sm7 md6 class="animated fadeInUp text-xs-left">
                          <p class="caja_texto" v-html="texto[onboarding]"></p>
                          </v-flex>
                          </v-layout>                       
                        </div>
                      </v-card>
                    </v-window-item>
                  </v-window>
                  <v-card-actions class="cont_buttons-slider">
                    <v-item-group light v-model="onboarding" class="text-center " mandatory>
                      <v-item v-for="n in length" :key="`btn-${n}`" v-slot:default="{ active, toggle }" >
                        <v-btn :color="vistos[n-1] ? '#ff9955ff' : '#28f7d1ff'" small class="item-button" :input-value="active" icon @click="toggle">
                          <v-icon>mdi-record</v-icon>
                        </v-btn>
                      </v-item>
                    </v-item-group>
                  </v-card-actions>
            </v-card>
      </v-flex>
      <v-flex xs12 sm7 md7 class="text-xs-left">
        <span><strong>Precauciones en la ejecución de la prueba de gases (oxígeno, gases inflamables y tóxicos)  </strong></span>
        <p>No deberá emitirse el permiso de trabajo si el resultado de la prueba de gases, en al menos una de las variables medidas, superan los siguientes valores: </p> 
      </v-flex>
        <!-- <v-flex xs12 sm7 md7 class="text-xs-left">
            <span><strong>Niveles de alarmas de oxígenos,  gases inflamables y tóxicos</strong></span>  
        </v-flex>  -->
    <v-flex xs12 sm9 md7 mt-3 mb-3 class="text-xs-left">
    <table class="tabla" style="margin: 0 auto;">
      <caption></caption> 
      <thead>
      <tr class="encabezado">
      <th scope="col" align="left">Variable </th>
      <th scope="col" align="left">Valores permitidos </th>
      </tr>
      </thead>
      <tbody> 
        <tr class="fila1">
          <td align="left">Oxígeno - % volumen</td>
          <td align="left">19.5%  a 23%</td>
        </tr>
        <tr>
          <td align="left">Explosividad - % LEL (Gas o vapor inflamable)</td>
          <td align="left">≤ 10 (Ideal 0%) </td>
        </tr>
        <tr> 
          <td align="left">Gases o vapores tóxicos - ppm </td>
          <td align="left">≤ TWA<br>  H2S:<= 1 ppm.<br>  CO:<= 25 ppm.<br>  SO2: 0 ppm </td> 
        </tr>
      </tbody>
      </table>
    </v-flex>
    <v-flex xs12 sm7 md7 class="text-xs-left">
        <p>Recuerda que el equipo tendrá la capacidad de medir las sustancias para las que tenga instalado su respectivo sensor. </p>
        <p>Lo ideal es contar con valores de <strong>cero para los gases inflamables y tóxicos.</strong> Cualquier parámetro por encima indicará que algo no está en control y, 
            por tanto, el trabajo no será seguro. Cada lectura debe tener un análisis de la evolución que puede tener durante la ejecución del trabajo. 
            Es necesario ampliar la frecuencia de monitoreo si la prueba marca valores diferentes al normalmente esperado con el fin de monitorear la condición atmosférica.  </p>
    </v-flex>
    <v-flex xs12 sm7 md7 mt-2> 
        <!-- <img class="animated flipInY dura-1" :src="require('../../assets/unidad2/pantalla 7-11.svg')" alt=""> -->
        <svg1-app @contenido="contenido($event)" v-if="!$vuetify.breakpoint.xs"></svg1-app > 
        <svg2-app @contenido="contenido($event)" v-if="$vuetify.breakpoint.xs"></svg2-app >
    </v-flex>
    </v-layout>
    <!-- modal svg1 -->
    <modal-app v-model="modalInfo" :fullscreen="false" :width="500">
      <template slot="modaltittle">
        <v-spacer></v-spacer>
      </template>  
      <template slot="modalcontent">
        <v-flex mb-3>
          <!-- <span><strong>3.</strong> Identifica la fuente del peligro</span> -->
        </v-flex>
        <v-layout wrap row justify-center align-center  mb-5>
          <v-flex xs5 sm3>
            <img :src="require('../../assets/unidad2/'+mensaje.icono+'.png')" alt="">
          </v-flex>
          <v-flex xs10 mt-4>
            <p v-html="mensaje.titulo"></p>
          </v-flex>
        </v-layout>
      </template>
    </modal-app>
  </div>
</template>
<script>
import nextConditions from "../../js/mixins/nextConditions";
import svg from "./svg/pantalla7web";
import svg2 from "./svg/pantalla7movil";
import svg3 from "./svg/pantalla7-1web";
import svg4 from "./svg/pantalla7-1movil";
export default {
  components: {
    "svg1-app": svg,
    "svg2-app": svg2,
    "svg3-app": svg3,
    "svg4-app": svg4,
  },
  mixins: [nextConditions],
  data() {
    return {
      length:8, 
      onboarding: 0,
      modalInfo:false,
      vistos:Array(10).fill(false), 
      dialogos: [
        '' 
      ],
      texto:[
        'La prueba de gases no garantiza que un trabajo sea seguro.  ',
        'No utilice el detector para probar gases inflamables o tóxicos en atmósferas ricas o deficientes en oxígeno, atmósferas inertes o chimeneas de hornos. ',
        'El equipo está diseñado para detectar gases y vapores solo en el aire. ',
        'Un equipo contaminado se debe apagar y dejar 2 días sin prenderlo hasta que los sensores reaccionen (tiempo requerido). ',
        'Se debe realizar el procedimiento ajuste y verificación con mayor frecuencia si el equipo detector está sometido a altos niveles de contaminantes. ',
        'La sensibilidad del sensor de gas inflamable puede reducir sus lecturas si hay presencia de: siliconas orgánicas, silicatos, compuestos que contengan plomo, exposiciones a H2S por encima de 200 ppm o mayores a 50 ppm durante 1 min.',
        'Los cambios de presión y humedad afectan la cantidad de oxígeno que realmente se encuentra presente en la atmósfera, por tanto, afecta la lectura del sensor de oxígeno, igualmente, si hay aumento de temperatura. ',
        'No es adecuado para detectar polvos o nieblas combustibles ',
      ],
      listas:[
          {
            titulo:"<strong>1.</strong> Seleccionar el o los equipos de medición requeridos para las sustancias a las que puede estar expuesta la ejecución del trabajo; esto porque no todos los equipos miden todas las sustancias. ",
            icono:"img1",
          },
          {
            titulo:"<strong>2.</strong> Identificar el tipo de actividad que se va a desarrollar (trabajo en caliente, en espacio confinado, etc.). ",
            icono:"img2",
          },
          {
            titulo:"<strong>3.</strong> Encender el equipo detector de gases y verificar su funcionamiento.",
            icono:"img3",
          },
          {
            titulo:"<strong>4.</strong> Verificar cuando fue calibración el equipo por última vez y asegurar que esté vigente la calibración. ",
            icono:"img4",
          },
          {
            titulo:"<strong>5.</strong> Calibrar el equipo en caso de que no exista registro o evidencia y/o haya duda. ",
            icono:"img5",
          },
          {
            titulo:"<strong>6.</strong> Realizar el monitoreo del área con el detector de gases.",
            icono:"img6",
          },
          {
            titulo:"<strong>7.</strong> Registrar los resultados obtenidos en la prueba de gases en el permiso de trabajo. ",
            icono:"img7",
          },
          {
            titulo:"<strong>8.</strong> Definir el tiempo de validez de la prueba de gases.",
            icono:"img8",
          },
      ],
      mensaje: {},
    }
  },
    created() {
    this.mensaje = this.listas[0]
    this.$set(this.vistos,0,true)
  },
  watch: {
    onboarding(val){
      this.$set(this.vistos,val,true)
    }
  },
  methods:{
    contenido(number){
      this.modalInfo=true
      this.mensaje = this.listas[number];
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../sass/globals';
.cont_buttons-slider{
  justify-content: center;
  .item-button{
    width: 15px;
    height: 15px;
  }
}
.flip-item{
  position: relative;
  width: 100%;
  height:auto;
  padding: 10px;
  p{
    text-align: center;
  }
  .pb{
    color: $color-secondary;
    font-family: FontBase-Bold;
  }
  @media screen and (max-width: 330px) {
    img{
      width: 150px;
    }
    
  }
}
.caja_texto{
  background:#ffff;
  padding: 5px 5px 5px 5px;
}
.lista {
    text-align: justify !important;
    background: greenyellow;
}
h1 li{
  text-align: justify
}
.encabezado{
  background: #c7ee95ff; 
}
td, th {
  border: #23cad9ff 1px solid;
  font-size: 13.6px;
}
table{
text-align:center;
}
</style>
